/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { screen } from "@eisinc/XDL/Helpers";
import { savedOrderDetailsHeaderStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsHeader";
import { css } from "styled-components";

savedOrderDetailsHeaderStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;

        ${screen("gt", "xs")`
            align-items: center;
        `}
    `,
    width: [2, 2, 5, 8, 8],
};
